import React, { useState } from 'react';
import c from './preview-panel.module.scss';
import { Icon } from '@monash/portal-react';

const PreviewPanel = () => {
  const [isDismissed, setIsDismissed] = useState(false);

  return import.meta.env.VITE_SHOW_PREVIEW_PANEL && !isDismissed ? (
    <div className={c.previewPanel}>
      This is a preview{' '}
      <button
        className={c.close}
        type="button"
        onClick={() => {
          setIsDismissed(true);
        }}
      >
        <Icon.X size={14} />
      </button>
    </div>
  ) : null;
};

export default PreviewPanel;
